import '../css/app.scss';
// browser support warnings
import './supportWarning';
// mapbox gl js map
import './map';
// main vue controller and type filters
import './controls';
// filter by years
import './years';
// calculate visible areas
import './area';
// map layers data query functions
import './mapQuery';
// collapse top menu
import './collapse';
// loading spinner
import './loading';
// onboarding tour
import './tour';



// WEBPACK FOOTER //
// ./src/js/app.js